export function firstErrorOrEmpty(errors, name) {
  const firstError = errors.find(error => error.path == name)

  return firstError ?
    firstError.message :
    ''
}
